import { parse, stringify } from "qs"
import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import axios from "axios";
import VueAxios from "vue-axios";
import vClickOutside from "click-outside-vue3"

import store from "./shared/store";
import helpers from "./shared/utils/helpers";

import componentDefinitions from "./component-definitions";
// Class that will be searched for to mount Vue components.
const vueComponentIdClass = "data-baseline-vue-component-id";

// Importing the global SCSS files
import "@/assets/button.scss"
import "@/assets/dropdown.scss"
import "@/assets/filters.scss"
import "@/assets/offcanvas.scss"
import "@/assets/vue-view.scss"
import "@/assets/pagination.scss"

((Drupal, drupalSettings, once) => {
  /**
   * Find components in the DOM to mount components to.
   *
   * @param context
   *   The current parent element context.
   * @param {string} elClass
   *   Class that will be searched for to mount Vue components.
   */
  const componentsFromContext = (context, elClass) => {

    const $elements = once(
      "vue-components",
      context.querySelectorAll(`[${elClass}]`)
    );

    [...$elements].forEach(element => {
      // Find a matching component.
      const matchedComponent = componentDefinitions.find(component => {
        return component.el === element.getAttribute(elClass);
      });

      if (matchedComponent) {
        // Change the component definition to be unique.
        const component = { ...matchedComponent };

        // Create the app with the component's definitions.
        const newApp= createApp(component);

        // Add the shared store to the app.
        newApp.use(store);

        // Add Axios to the app.
        newApp.use(VueAxios, axios);

        // Add clickAway to the app.
        newApp.use(vClickOutside);

        // Add helpers to the app.
        newApp.config.globalProperties.$helpers = helpers;
        newApp.config.globalProperties.$drupal = Drupal || {};
        newApp.config.globalProperties.$drupalSettings = window.drupalSettings || {};

        // Add window location to the app.
        newApp.config.globalProperties.$window = window;

        const routes = []
        const router = createRouter({
          history: createWebHistory(),
          routes,
          parseQuery: parse,
          stringifyQuery: stringify,
          // Disable autoscrolling on router changes.
          scrollBehavior(to, from, savedPosition) {
            return false
          },
        });

        newApp.use(router);

        // // Mount the app to the correct element.
        newApp.mount(`#${element.id}`)
      }
    });
  };

  /**
   * Main function.
   */
  const init = (context) => {
    // Set up axios.
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        const UNAUTHORIZED = 401;
        const FORBIDDEN = 403;
        if (
          error.response &&
          (error.response.status === UNAUTHORIZED ||
            error.response.status === FORBIDDEN)
        ) {
          window.location.reload();
        }
        return Promise.reject(error);
      }
    );

    // Match and mount components found in the document.
    componentsFromContext(context, vueComponentIdClass);
  };

  if (Drupal) {
    Drupal.behaviors.baselineVue = {
      attach: (context) => {
        init(context);
      }
    };
  }
  else {
    Drupal = {
      t: function(text) {
        return text
      }
    };
    init(document);
  }

})(window.Drupal, window.drupalSettings, window.once);
